import React from 'react'
import { Link } from 'gatsby'

// https://github.com/gatsbyjs/gatsby/issues/7208#issuecomment-415965156
const isPartiallyActive = ({ isPartiallyCurrent }) =>
  isPartiallyCurrent ? { className: "current" } : null;

  const PartialNavLink = props => (
    <Link getProps={isPartiallyActive} {...props} />
  )

  export default PartialNavLink;